import Service from "../Service"

const statistic = {
  getStatistic(params) {
    return Service.get(`/api/frontend/statistic`, {
      params: params
    })
  },
  getStatisticById(id, params) {
    return Service.get(`/api/frontend/statistic/${id}`, {
      params: params
    })
  },
  getAvailableYear() {
    return Service.get(`/api/frontend/year`)
  }
}

export default statistic
